import { add, parseISO } from '@sequencehq/utils/dates'
import { BillingSchedule } from 'modules/Customer/hooks/useFetchBillingSchedules'

/**
 * A fixed-end schedule renews on from the day after it ends when no explicit
 * date is chosen. An open-ended schedule has no such fallback.
 */
export const getFixedEndRenewOnDate = (
  schedule: BillingSchedule | undefined
): Date | undefined =>
  schedule?.endDate ? add(parseISO(schedule.endDate), { days: 1 }) : undefined
